import { MIN_TRIP_SEARCH_TERM_LENGTH } from './constants';

/** Omits the param for a term too short to be a useful search. */
export function tripSearchParams(term: string): { search?: string } {
  const trimmed = term.trim();

  return trimmed.length >= MIN_TRIP_SEARCH_TERM_LENGTH
    ? { search: trimmed }
    : {};
}
